import { loadMessages } from '../common/api';

const messages = {
    name: 'messages',
    state: {
        loaded: false, 
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.nid
            }
        },
        cdcInsert: ( state, payload ) => {
            // might receive assoc insert first, so can't assume first time seeing anying for this id
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.mid]: {
                        ...state.byId[payload.mid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.mid]: {
                        ...state.byId[payload.mid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.mid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedMessages: ( state, payload ) => {
            return {
                ...state,
                loaded: true,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadMessages( { aid, uid } ) {
            const list = await loadMessages( aid, uid );
            let byId = {};
            if ( list && list.length ) {
                list.forEach( c => byId[c.mid] = c );
                dispatch.messages.loadedMessages( byId );
            }
            return list;
        },
        insert( { mid, cdc } ) {
            dispatch.messages.cdcInsert( { mid, cdc } );
        },
        modify( { mid, cdc } ) {
            dispatch.messages.cdcModify( { mid, cdc } );
        },
        remove( { mid } ) {
            dispatch.messages.cdcRemove( { mid } );
        },
        setCurrent( { mid } ) {
            dispatch.messages.setCurrentId( { mid } );
        }
    } )
}

export default messages;